<template>
	<div>
		<el-button circle icon="el-icon-back" class="boton-agregar" @click="$router.back()" />
		<h1 class="centrar">
			Envases
		</h1>
		<template v-if="esHoy">
			<h3 class="centrar">Cargar envases</h3>
			<el-table :data="nuevoEnvase" :row-style="setRowHeight" class="tabla">
				<el-table-column label="Producto">
					<template #default="scope">
						<el-select v-model="scope.row.productoId" placeholder="Seleccione">
							<el-option v-for="prod in productos" :key="prod.id" :label="prod.nombre" :value="prod.id" />
						</el-select>
					</template>
				</el-table-column>
				<el-table-column label="Cantidad">
					<template #default="scope">
						<el-input v-model="scope.row.cantidad" :min="0" />
					</template>
				</el-table-column>
				<el-table-column width="50">
					<template #default="scope">
						<el-button @click="eliminarFila(scope.$index)" icon="el-icon-close" circle size="mini" />
					</template>
				</el-table-column>
			</el-table>
			<div class="container-btn">
				<el-button type="primary" @click="agregarFila" icon="el-icon-plus" class="btn">
					Agregar envase
				</el-button>
			</div>
			<div class="container-btn">
				<el-button type="success" @click="guardarEnvasesConFeedback" class="btn">
					Finalizar
				</el-button>
			</div>
		</template>
	</div>
</template>
<script>
export default {
	name: 'Envases',
	data() {
		return {
			nuevoEnvase: [],
		};
	},
	computed: {
		productos() {
			return this.$store.getters['detalleCliente/envaseDisponible'];
		},
		cliente() {
			return this.$store.state.detalleCliente.cliente;
		},
		fechaActual() {
			return this.$store.state.detalleCliente.fechaActual;
		},
		esHoy() {
			const hoy = new Date().toISOString().slice(0, 10);
			return hoy === this.fechaActual;
		},
		envasesValidos() {
			return this.nuevoEnvase.filter(p => p.productoId && p.cantidad >= 0);
		},
	},
	created() {
		if (!this.productos.length) this.$store.dispatch('detalleCliente/fetchEnvases');
		const clienteId = this.$route.query.clienteId;
		const fecha = this.$route.query.fecha;

		if (clienteId && fecha) {
			this.$store.dispatch('detalleCliente/fetchDetalle', {
				id: clienteId,
				fecha,
			});
		}
	},
	methods: {
		agregarFila() {
			this.nuevoEnvase.push({ productoId: null, cantidad: 1 });
		},
		eliminarFila(index) {
			this.nuevoEnvase.splice(index, 1);
		},
		async guardarEnvasesConFeedback() {
			try {
				await this.$store.dispatch('detalleCliente/guardarEnvases', this.envasesValidos);
				this.$message.success('Envases guardados correctamente');
				this.$router.push({ name: 'Visitas' });
			} catch (e) {
				console.error(e);
				this.$message.error('Error al guardar los envases');
			}
		},
		setRowHeight() {
			return { height: '60px' };
		},
	},
};
</script>
<style scoped>
.centrar {
	text-align: center;
}
.container-btn {
	width: 50%;
	margin: 10px auto;
}
.btn {
	width: 100%;
	padding: 10px;
}
.boton-agregar {
	margin-left: 5px;
	margin-top: 5px;
	border: none;
}
.tabla {
	margin-top: 20px;
}
</style>
